import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppHomePageModalNotifyComponent } from '../app-home-page-modal-notify/app-home-page-modal-notify.component';
import moment from 'moment';
@Component({
  selector: 'meu-app-home-page',
  templateUrl: './app-home-page.component.html',
  styleUrls: ['./app-home-page.component.scss'],
})
export class AppHomePageComponent implements OnInit {
  constructor(public dialog: MatDialog) {}

  ngOnInit() {}

  ngAfterViewInit(): void {
    const finishDate = moment(new Date(2021, 8, 30, 23, 59, 59)).format('YYYY-MM-DD HH:mm:ss');
    const currentDate = moment().format('YYYY-MM-DD HH:mm:ss');
    if (currentDate <= finishDate) {
      setTimeout(() => {
        const dialogRef = this.dialog.open(AppHomePageModalNotifyComponent, {
          data: {},
          panelClass: 'my-popup-notify-custom',
        });
        dialogRef.afterClosed().subscribe((result) => {});
      }, 2000);
    }
  }
}
